import api, { V1 } from './axios';

export const authApi = {
  signup: (data: { name: string; email: string; password: string; gender: string; age: number; referral_code?: string }) =>
    api.post(`${V1}auth/signup/`, data),

  verifyOtp: (data: { email: string; otp: string }) =>
    api.post(`${V1}auth/verify-otp/`, data),

  // Re-sends the signup code off the cached pending registration — no need to
  // resubmit the password/PII (which the verify page doesn't hold anyway).
  resendOtp: (data: { email: string }) =>
    api.post(`${V1}auth/resend-otp/`, data),

  login: (data: { email: string; password: string }) =>
    api.post(`${V1}auth/login/`, data),

  googleLogin: (data: { token: string }) =>
    api.post(`${V1}auth/google-login/`, data),

  refreshToken: (data: { refresh: string }) =>
    api.post(`${V1}auth/token/refresh/`, data),

  forgotPassword: (data: { email: string }) =>
    api.post(`${V1}auth/forgot-password/`, data),

  resetPassword: (data: { email: string; otp: string; new_password: string; confirm_password: string }) =>
    // Backend expects `code` + `confirm_password`; map our `otp` field to `code`.
    api.post(`${V1}auth/reset-password/`, {
      email: data.email,
      code: data.otp,
      new_password: data.new_password,
      confirm_password: data.confirm_password,
    }),

  getProfile: () =>
    api.get(`${V1}auth/user-profile/`),

  updateProfile: (data: { name?: string; gender?: string; age?: number; phone?: string }) =>
    api.put(`${V1}auth/user-profile/`, data),

  completeProfile: (data: { name: string; gender: string; age: number; referral_code?: string }) =>
    api.post(`${V1}auth/complete-profile/`, data),

  acceptTerms: () =>
    api.post(`${V1}auth/accept-terms/`),

  deleteAccount: (data: { email: string; password?: string }) =>
    api.post(`${V1}auth/delete-account/`, data),

  // No wallet on Recovry. Kept so legacy call sites compile until
  // Wallet.tsx / wallet references are removed in Phase 6.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getWallet: (): Promise<{ data: any }> =>
    Promise.resolve({ data: { balance: 0, wallet_balance: 0, transactions: [], wallet: { balance: 0 } } }),

  getAddresses: () =>
    api.get(`${V1}auth/saved-addresses/`),

  addAddress: (data: { label: string; address: string; pincode: string; landmark?: string }) =>
    api.post(`${V1}auth/saved-addresses/`, data),

  updateAddress: (data: { address_id: string; label: string; address: string; pincode: string; landmark?: string }) =>
    api.put(`${V1}auth/saved-addresses/`, data),

  deleteAddress: (data: { address_id: string }) =>
    api.delete(`${V1}auth/saved-addresses/`, { data }),
};
